// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image-module--wrapper--3jUWJ","fullImage_wrapper":"image-module--fullImage_wrapper--2U9v_","wideImage_wrapper":"image-module--wideImage_wrapper--RFgcd"};